interface Testimonial {
  name: string;
  rating: number;
  content: string;
  result?: string;
  role?: string;
  location?: string;
}

interface CenterTestimonial extends Testimonial {
  center: string;
  state: 'NSW' | 'VIC';
}

// All testimonials from NSW centers
const nswTestimonials: CenterTestimonial[] = [
  // Colebee
  {
    name: 'Kanu Mehrok',
    rating: 5,
    content: "This tutoring centre was probably one of the best decisions I made in the last few months for my daughter, their teachers are very hardworking and dedicated to improving every individual students progress. I highly recommend Schoolola Tutoring to all parents who want to see a change in their child's education.",
    result: 'Best decision for daughter\'s education',
    center: 'Colebee',
    state: 'NSW',
    role: 'Parent',
    location: 'Colebee, NSW'
  },
  {
    name: 'Aliya Topal',
    rating: 5,
    content: "I have been to a lot of places and actually lost hope in my son's ability to learn. But when we found this place and my son has been continuing now for a year he has excelled exceptionally well. I love how they alter things to your child's needs.",
    result: 'Son excelled exceptionally well after a year',
    center: 'Colebee',
    state: 'NSW',
    role: 'Parent',
    location: 'Colebee, NSW'
  },
  {
    name: 'Johnn Panlilio',
    rating: 5,
    content: "Excellent tutor teachers. Clear, patient, and highly effective. Highly recommend! Especially if you're in the area. Very flexible and catering to specific subjects English and Math. Great for OC and selective preparations",
    result: 'Excellent OC and selective preparations',
    center: 'Colebee',
    state: 'NSW',
    role: 'Parent',
    location: 'Colebee, NSW'
  },
  // Riverstone
  {
    name: 'Jyothi Kumari',
    rating: 5,
    content: "Schoolola has been instrumental in my child's academic growth. The structured approach and individual attention have helped build a strong foundation in both Math and English.",
    result: 'Strong foundation in Math and English',
    center: 'Riverstone',
    state: 'NSW',
    role: 'Parent',
    location: 'Riverstone, NSW'
  }
];

// All testimonials from VIC centers  
const vicTestimonials: CenterTestimonial[] = [
  // Tarneit
  {
    name: 'Ehsan',
    rating: 5,
    content: "Thanks we appreciate your help. The support provided has been exceptional and my children have shown great improvement.",
    result: 'Grateful for excellent support',
    center: 'Tarneit',
    state: 'VIC',
    role: 'Parent',
    location: 'Tarneit, VIC'
  },
  {
    name: 'Kogula Vengidasalam',
    rating: 5,
    content: "We're really happy with the tuition services here. The teachers and staff are all very helpful and supportive, and my son looks forward to going to class.",
    result: 'Improved confidence and engagement in learning',
    center: 'Tarneit',
    state: 'VIC',
    role: 'Parent',
    location: 'Tarneit, VIC'
  }
];

// Function to shuffle array using Fisher-Yates algorithm
function shuffleArray<T>(array: T[]): T[] {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
}

// Get testimonials based on selected state
export function getRandomizedTestimonials(
  selectedState?: string | null, 
  count: number = 6
): CenterTestimonial[] {
  let testimonials: CenterTestimonial[] = [];
  
  if (selectedState === 'NSW') {
    testimonials = nswTestimonials;
  } else if (selectedState === 'VIC') {
    testimonials = vicTestimonials;
  } else {
    // Do not surface NSW-only OC or Selective claims to visitors in other states.
    const isStateAppropriate = (testimonial: CenterTestimonial) =>
      !/\bOC\b|selective preparation/i.test(
        `${testimonial.content} ${testimonial.result ?? ''}`,
      );
    testimonials = [...nswTestimonials, ...vicTestimonials].filter(isStateAppropriate);
  }
  
  // Randomize and return the requested count
  return shuffleArray(testimonials).slice(0, count);
}

// Get all testimonials for a specific center
export function getTestimonialsByCenter(centerName: string): CenterTestimonial[] {
  const allTestimonials = [...nswTestimonials, ...vicTestimonials];
  return allTestimonials.filter(testimonial => 
    testimonial.center.toLowerCase() === centerName.toLowerCase()
  );
}

// Get testimonials by state
export function getTestimonialsByState(state: 'NSW' | 'VIC'): CenterTestimonial[] {
  return state === 'NSW' ? nswTestimonials : vicTestimonials;
}